import React from "react";
import { Container } from "react-bootstrap";

export default function CancellationRefunds() {
  return (
    <Container className="py-5">
      <h2>Cancellation & Refund Policy</h2>
      <p className="mt-3">
        We do not provide cancellations or refunds once a subscription or
        payment has been made. TickTickGo offers a <strong>30-day free trial</strong> period,
        allowing you to explore all features before subscribing.
      </p>
      <p>
        After the trial period, payment is required based on the
        subscription packages that we offer. Please review the details
        carefully before making any purchase.
      </p>
    </Container>
  );
}
